import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { useFormik } from "formik";
import { useParams } from "react-router-dom";
import { ToastOptions, toast } from "react-toastify";
import styled from "styled-components";
import { StyledButton } from "../../../../components/Button/button";
import { theme } from "../../../../helpers/theme";
import { addressVoivodeshipsList } from "../../../../helpers/voievodeshipsList";
import { addressAdd } from "../../../../services/address/add";
import { putAddressUpdate } from "../../../../services/address/update";
import { putSubcontractorUpdate } from "../../../../services/subcontractor/update";
import * as yup from "yup";
import { Input } from "../../../../components/Input/input";
import { Contractor } from "../../../../services/subcontractor/get-all/types";


export const AddressSubcontractorEditForm = (subcontractorData: Contractor[]) => {
  const { id } = useParams();

  const aData = subcontractorData[0];

  const settings: ToastOptions<{}> = {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    theme: "light",
  };

  const editAddressMutation = useMutation(putAddressUpdate, {
    onSuccess: (res) => {
      toast.success("Edytowano pomyślnie!", {
        toastId: "EditSuccessfully",
        ...settings,
      });
    },
  });

  const EditSubcontractorMutation = useMutation(putSubcontractorUpdate, {
    onSuccess: (res) => { },
  });

  const addAdressMutation = useMutation(addressAdd, {
    onSuccess: (res) => {
      toast.success("Edytowano pomyślnie!", {
        toastId: "EditSuccessfully",
        ...settings,
      });
      const bodyBasic = {
        id: id,
        nazwa_wykonawcy: aData.nazwa_wykonawcy,
        nip: aData.nip,
        telefon: aData.telefon,
        email: aData.email,
        // info_dodatkowe: aData.info_dodatkowe,
        aktywny: aData.aktywny,
        // aktywny_data_do: aData.aktywny_data_do,
        adres_id: res.data.payload.id_klient,
      };
      EditSubcontractorMutation.mutate(bodyBasic);
    },
  });

  const postalCodeRegExp = /^[0-9]{2}-[0-9]{3}/;

  const validationSchema = yup.object({
    kod_pocztowy: yup
      .string()
      .required("Kod pocztowy jest wymagany")
      .matches(postalCodeRegExp, "Błędny format!")
      .min(6, "Błędny format!")
      .max(6, "Błędny format!"),
    miejscowosc_poczty: yup
      .string(),
    miejscowosc: yup
      .string()
      .max(100, "Miejscowość nie może być dłuższa niż 100 znaków")
      .required("Miejscowość jest wymagana"),
    ulica: yup
      .string()
      .max(100, "Ulica nie może być dłuższa niż 100 znaków"),
    numer_budynku: yup
      .string()
      .max(5, "Numer budynku nie może być dłuższy niż 5 znaków")
      .required("Numer budynku jest wymagany"),
    numer_lokalu: yup
      .number()
      .typeError("Błędny format!")
      .max(99999, "Numer lokalu nie może być dłuższy niż 5 znaków"),
    wojewodztwo: yup
      .string()
      .required("Województwo jest wymagane"),
    kraj: yup
      .string()
      .required("Kraj jest wymagany"),
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      kod_pocztowy: aData?.adres_siedziby ? aData.adres_siedziby.kod_pocztowy : "",
      miejscowosc_poczty: aData?.adres_siedziby
        ? aData.adres_siedziby.miejscowosc_poczty
        : "",
      miejscowosc: aData?.adres_siedziby ? aData.adres_siedziby.miejscowosc : "",
      ulica: aData?.adres_siedziby ? aData.adres_siedziby.ulica : "",
      numer_budynku: aData?.adres_siedziby ? aData.adres_siedziby.numer_budynku : "",
      numer_lokalu: aData?.adres_siedziby ? aData.adres_siedziby.numer_lokalu : "",
      wojewodztwo: aData?.adres_siedziby ? aData.adres_siedziby.wojewodztwo : "",
      kraj: "Polska",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const body = {
        id_wykonawca: id,
        kod_pocztowy: values.kod_pocztowy,
        miejscowosc_poczty: values.miejscowosc,
        miejscowosc: values.miejscowosc,
        ulica: values.ulica === "" ? null : values.ulica,
        numer_budynku: values.numer_budynku,
        numer_lokalu: values.numer_lokalu === "" ? null : values.numer_lokalu,
        wojewodztwo: values.wojewodztwo,
        kraj: "Polska",
      };

      if (aData.adres_siedziby) {
        editAddressMutation.mutate(body);
      } else {
        addAdressMutation.mutate(body);
      }
    },
  });


  return (
    <AddressSubcontractorEditFormWrapper onSubmit={formik.handleSubmit}>
      <FormWrapper>
        <Input
          label="Kod pocztowy"
          id="kod_pocztowy"
          name="kod_pocztowy"
          value={formik.values.kod_pocztowy}
          onChange={formik.handleChange}
          error={
            formik.touched.kod_pocztowy && Boolean(formik.errors.kod_pocztowy)
          }
          helperText={formik.touched.kod_pocztowy && formik.errors.kod_pocztowy}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        {/* <Input
            label="Miejscowość poczty"
            id="miejsowosc_poczty"
            name="miejscowosc_poczty"
            value={formik.values.miejscowosc_poczty}
            onChange={formik.handleChange}
            error={formik.touched.miejscowosc_poczty && Boolean(formik.errors.miejscowosc_poczty)}
            helperText={formik.touched.miejscowosc_poczty && formik.errors.miejscowosc_poczty}
            onBlur={formik.handleBlur}
            variant="filled"
            style={{ marginTop: 11 }}
          /> */}
        <Input
          label="Miejscowość"
          id="miejscowosc"
          name="miejscowosc"
          value={formik.values.miejscowosc}
          onChange={formik.handleChange}
          error={
            formik.touched.miejscowosc && Boolean(formik.errors.miejscowosc)
          }
          helperText={formik.touched.miejscowosc && formik.errors.miejscowosc}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <Input
          label="Ulica"
          id="ulica"
          name="ulica"
          value={formik.values.ulica}
          onChange={formik.handleChange}
          error={formik.touched.ulica && Boolean(formik.errors.ulica)}
          helperText={formik.touched.ulica && formik.errors.ulica}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <Input
          label="Numer budynku"
          id="numer_budynku"
          name="numer_budynku"
          value={formik.values.numer_budynku}
          onChange={formik.handleChange}
          error={
            formik.touched.numer_budynku && Boolean(formik.errors.numer_budynku)
          }
          helperText={
            formik.touched.numer_budynku && formik.errors.numer_budynku
          }
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <Input
          label="Numer lokalu"
          id="numer_lokalu"
          name="numer_lokalu"
          value={formik.values.numer_lokalu}
          onChange={formik.handleChange}
          error={
            formik.touched.numer_lokalu && Boolean(formik.errors.numer_lokalu)
          }
          helperText={formik.touched.numer_lokalu && formik.errors.numer_lokalu}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <FormControl fullWidth>
          <InputLabel id="wojewodztwoLabel">Województwo</InputLabel>
          <Select
            placeholder="Województwo"
            labelId="wojewodztwoLabel"
            id="wojewodztwo"
            name="wojewodztwo"
            value={formik.values.wojewodztwo}
            label="Województwo"
            onChange={formik.handleChange}
            // disabled={!isEditable}
            style={{ backgroundColor: "white" }}
          >
            {addressVoivodeshipsList.map((item) => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Input
          disabled
          label="Kraj"
          id="kraj"
          name="kraj"
          value={formik.values.kraj}
          onChange={formik.handleChange}
          error={formik.touched.kraj && Boolean(formik.errors.kraj)}
          helperText={formik.touched.kraj && formik.errors.kraj}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <StyledButton
          disabled={
            !formik.isValid ||
            editAddressMutation.isLoading ||
            addAdressMutation.isLoading
          }
          type="submit"
          variant="contained"
        >
          Zapisz
        </StyledButton>
      </FormWrapper>
    </AddressSubcontractorEditFormWrapper>
  );
};

export default AddressSubcontractorEditForm;

const AddressSubcontractorEditFormWrapper = styled.form`
  width: 100%;
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
  // padding: 0 40px;

  @media (${theme.device.laptop}) {
    width: 100%;
    // padding: 0 10px;
  }
`;

const FormWrapper = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 260px;
  max-width: 420px;
  gap: 25px;

  @media (${theme.device.laptop}) {
    width: 100%;
  }
`;
